export const trackPixelEvent = (
  event: string,
  data?: Record<string, unknown>,
  extraData?: Record<string, unknown>
) => {
  // Gửi Meta (Facebook) Pixel
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq('track', event, data, extraData)
  }

  // Gửi TikTok Pixel nếu có
  if (typeof window !== 'undefined') {
    const ttq = window.ttq
    if (ttq && typeof ttq.track === 'function') {
      const { name, payload } = mapToTikTok(event, data)
      ttq.track(name, payload)
    }
  }
}

// Ánh xạ event + payload từ FB sang TikTok
function mapToTikTok(
  event: string,
  data?: Record<string, unknown>
): { name: string; payload: Record<string, unknown> } {
  // Gộp dữ liệu an toàn
  const d = data || {}

  // Chuẩn hóa id(s)
  const ids = Array.isArray(d['content_ids'])
    ? (d['content_ids'] as unknown[])
    : d['content_ids']
      ? String(d['content_ids'])
          .split(',')
          .map((s) => s.trim())
          .filter(Boolean)
      : d['content_id']
        ? [String(d['content_id'])]
        : []

  // TikTok khuyến nghị truyền contents để đo lường chuẩn
  const contents =
    Array.isArray(d['contents']) && d['contents']?.length
      ? d['contents']
      : ids.map((id) => ({
          content_id: id,
          content_type: d['content_type'] || 'product',
          quantity: Number(d['quantity'] ?? 1),
          price: Number(d['price'] ?? d['value'] ?? 0),
        }))

  const basePayload: Record<string, unknown> = {
    // Các trường chung TikTok hỗ trợ
    contents,
    content_type: d['content_type'],
    value: Number(d['value'] ?? 0),
    currency: d['currency'] || 'MYR',
  }

  // Ánh xạ tên event
  // Lưu ý: TikTok dùng 'CompletePayment' cho đơn hoàn tất
  const eventMap: Record<string, string> = {
    ViewContent: 'ViewContent',
    AddToCart: 'AddToCart',
    InitiateCheckout: 'InitiateCheckout',
    AddPaymentInfo: 'AddPaymentInfo',
    Purchase: 'CompletePayment',
    CompletePayment: 'CompletePayment',
    Search: 'Search',
    Contact: 'Contact',
    SubmitForm: 'SubmitForm',
  }

  const name = eventMap[event] || event

  return { name, payload: basePayload }
}
